"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r = n(e),
    i = function i(e) {
  var n = e.page,
      i = e.pageHeight,
      a = e.pageIndex,
      u = e.pageWidth,
      c = e.rotation,
      o = e.thumbnailHeight,
      s = e.thumbnailWidth,
      l = r.useContext(t.LocalizationContext),
      g = r.useRef(),
      p = r.useState(""),
      h = p[0],
      f = p[1],
      d = l && l.thumbnail ? l.thumbnail.thumbnailLabel : "Thumbnail of page {{pageIndex}}";
  return r.useEffect(function () {
    var e = g.current;
    e && e.cancel();
    var t = document.createElement("canvas"),
        r = t.getContext("2d", {
      alpha: !1
    }),
        a = s,
        o = a / (u / i),
        l = a / u;
    t.height = o, t.width = a, t.style.height = o + "px", t.style.width = a + "px";
    var p = n.getViewport({
      rotation: c,
      scale: l
    });
    g.current = n.render({
      canvasContext: r,
      viewport: p
    }), g.current.promise.then(function () {
      return f(t.toDataURL());
    }, function () {});
  }, [c]), h ? r.createElement("img", {
    "aria-label": d.replace("{{pageIndex}}", "" + (a + 1)),
    src: h,
    height: o + "px",
    width: s + "px"
  }) : r.createElement(t.Spinner, null);
},
    a = function a(e) {
  var n = e.doc,
      a = e.isActive,
      u = e.pageHeight,
      c = e.pageIndex,
      o = e.pageWidth,
      s = e.rotation,
      l = e.onActive,
      g = r.useState({
    height: u,
    isCalculated: !1,
    page: null,
    viewportRotation: 0,
    width: o
  }),
      p = g[0],
      h = g[1],
      f = r.useRef({
    isVisible: !1,
    ratio: 0
  }),
      d = p.isCalculated,
      b = p.page,
      m = p.height,
      v = p.width,
      x = v / m,
      w = Math.abs(s) % 180 == 0,
      E = w ? 100 : 100 / x,
      y = w ? 100 / x : 100;
  r.useLayoutEffect(function () {
    if (a) {
      var e = _.current,
          t = f.current;
      (!t.isVisible || t.ratio < 1) && l(e);
    }
  }, [a]);

  var P = (s + p.viewportRotation) % 360,
      _ = t.useIntersectionObserver({
    onVisibilityChanged: function onVisibilityChanged(e) {
      f.current = e, e.isVisible && !d && n.getPage(c + 1).then(function (e) {
        var t = e.getViewport({
          scale: 1
        });
        h({
          height: t.height,
          isCalculated: !0,
          page: e,
          viewportRotation: t.rotation,
          width: t.width
        });
      });
    }
  });

  return r.createElement("div", {
    className: "rpv-thumbnail__container",
    ref: _,
    style: {
      height: y + "px",
      width: E + "px"
    }
  }, b ? r.createElement(i, {
    page: b,
    pageHeight: w ? m : v,
    pageIndex: c,
    pageWidth: w ? v : m,
    rotation: P,
    thumbnailHeight: y,
    thumbnailWidth: E
  }) : r.createElement(t.Spinner, null));
},
    u = function u(e) {
  var n = e.currentPage,
      i = e.doc,
      u = e.pageHeight,
      c = e.pageWidth,
      o = e.rotation,
      s = e.onJumpToPage,
      l = i.numPages,
      g = r.useRef(null),
      p = r.useRef([]),
      h = r.useState(n),
      f = h[0],
      d = h[1],
      b = function b(e) {
    var t = g.current;
    t && function (e, t) {
      var n = e.getBoundingClientRect().top - t.getBoundingClientRect().top,
          r = e.clientHeight,
          i = t.clientHeight;
      n < 0 ? t.scrollTop += n : n + r <= i || (t.scrollTop += n + r - i);
    }(e.parentElement, t);
  },
      m = function m() {
    if (g.current) {
      var e = p.current,
          t = f + 1;
      t < e.length && (f >= 0 && e[f].setAttribute("tabindex", "-1"), d(t));
    }
  },
      v = function v() {
    if (g.current) {
      var e = p.current,
          t = f - 1;
      t >= 0 && (f >= 0 && e[f].setAttribute("tabindex", "-1"), d(t));
    }
  },
      x = function x() {
    f >= 0 && f < l && s(f);
  };

  return t.useIsomorphicLayoutEffect(function () {
    var e = g.current;
    e && (p.current = Array.from(e.querySelectorAll(".rpv-thumbnail__item")));
  }, []), r.useEffect(function () {
    var e = p.current;

    if (!(0 === e.length || f < 0 || f > e.length)) {
      var t = e[f];
      t.setAttribute("tabindex", "0"), t.focus();
    }
  }, [f]), r.createElement("div", {
    ref: g,
    className: "rpv-thumbnail__list",
    onKeyDown: function onKeyDown(e) {
      switch (e.key) {
        case "ArrowDown":
          m();
          break;

        case "ArrowUp":
          v();
          break;

        case "Enter":
          x();
      }
    }
  }, Array(l).fill(0).map(function (e, l) {
    return r.createElement("div", {
      className: t.classNames({
        "rpv-thumbnail__item": !0,
        "rpv-thumbnail__item--selected": n === l
      }),
      key: "thumbnail-" + l,
      role: "button",
      tabIndex: n === l ? 0 : -1,
      onClick: function onClick() {
        return s(l);
      }
    }, r.createElement(a, {
      doc: i,
      isActive: n === l,
      pageHeight: u,
      pageIndex: l,
      pageWidth: c,
      rotation: o,
      onActive: b
    }));
  }));
},
    c = function c(e) {
  var n = e.store,
      i = r.useState(n.get("doc")),
      a = i[0],
      c = i[1],
      o = r.useState(n.get("currentPage") || 0),
      s = o[0],
      l = o[1],
      g = r.useState(n.get("pageHeight") || 0),
      p = g[0],
      h = g[1],
      f = r.useState(n.get("pageWidth") || 0),
      d = f[0],
      b = f[1],
      m = r.useState(n.get("rotation") || 0),
      v = m[0],
      x = m[1],
      w = function w(e) {
    l(e);
  },
      E = function E(e) {
    c(e);
  },
      y = function y(e) {
    h(e);
  },
      P = function P(e) {
    b(e);
  },
      _ = function _(e) {
    x(e);
  };

  return r.useEffect(function () {
    return n.subscribe("doc", E), n.subscribe("pageHeight", y), n.subscribe("pageWidth", P), n.subscribe("rotation", _), function () {
      n.unsubscribe("doc", E), n.unsubscribe("pageHeight", y), n.unsubscribe("pageWidth", P), n.unsubscribe("rotation", _);
    };
  }, []), t.useIsomorphicLayoutEffect(function () {
    return n.subscribe("currentPage", w), function () {
      n.unsubscribe("currentPage", w);
    };
  }, []), a ? r.createElement(u, {
    currentPage: s,
    doc: a,
    pageHeight: p,
    pageWidth: d,
    rotation: v,
    onJumpToPage: function onJumpToPage(e) {
      var t = n.get("jumpToPage");
      t && t(e);
    }
  }) : r.createElement("div", {
    className: "rpv-thumbnail__loader"
  }, r.createElement(t.Spinner, null));
};

exports.thumbnailPlugin = function () {
  var e = r.useMemo(function () {
    return t.createStore({});
  }, []);
  return {
    install: function install(t) {
      e.update("jumpToPage", t.jumpToPage);
    },
    onDocumentLoad: function onDocumentLoad(t) {
      e.update("doc", t.doc);
    },
    onViewerStateChange: function onViewerStateChange(t) {
      return e.update("currentPage", t.pageIndex), e.update("pageHeight", t.pageHeight), e.update("pageWidth", t.pageWidth), t;
    },
    Thumbnails: function Thumbnails() {
      return r.createElement(c, {
        store: e
      });
    }
  };
};